import VisibleLoading from '@/components/utilities/VisibleLoading';
import GlossaryCategoryTag from './GlossaryCategoryTag';

const GlossaryHero = ({ title, perex, categories = [], eyebrow }) => {
  return (
    <header className="border-grey-200 border-b pt-14 pb-16">
      <VisibleLoading delay={75}>
        {({ ref, className }) => (
          <span
            ref={ref}
            className={`text-brand-500 mb-5 inline-block text-[11px] font-bold tracking-[0.12em] uppercase ${className || ''}`.trim()}
          >
            {eyebrow}
          </span>
        )}
      </VisibleLoading>

      <VisibleLoading delay={100}>
        {({ ref, className }) => (
          <h1 ref={ref} className={`text-grey-950 mb-5 max-w-[680px] ${className || ''}`.trim()}>
            {title}
          </h1>
        )}
      </VisibleLoading>

      {perex && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <p ref={ref} className={`text-grey-600 max-w-[640px] text-lg leading-[1.7] ${className || ''}`.trim()}>
              {perex}
            </p>
          )}
        </VisibleLoading>
      )}

      {categories.length > 0 && (
        <VisibleLoading delay={200}>
          {({ ref, className }) => (
            <div ref={ref} className={`mt-6 flex flex-wrap gap-2 ${className || ''}`.trim()}>
              {categories.map((category) => (
                <GlossaryCategoryTag key={category.id} name={category.name} color={category.color} />
              ))}
            </div>
          )}
        </VisibleLoading>
      )}
    </header>
  );
};

export default GlossaryHero;
